import idx from 'idx';
import { graphql, readInlineData } from 'react-relay';
import { localStorage } from 'dibs-browser-storage';

// should be valid till 2019/12/31 at 11:59:59PM
const SHOW_MODAL_TILL_DATE = new Date('2020-01-01');
const POINTS_THRESHOLD_LEVEL_UP = 10000;
const HAS_SEEN_2019_EOY_REWARDS_MODAL_STORAGE_KEY = 'HAS_SEEN_2019_EOY_REWARDS_MODAL_STORAGE_KEY';

const rewardsFragment = graphql`
    fragment tradeRewardsEndOfYearMessagingHelpers_rewards on TradeFirmRewards @inline {
        pointsToMaintainStatus
        pointsNeededToLevelUp
        currentProgram {
            programInfo {
                code
            }
        }
    }
`;

import {
    tradeRewardsEndOfYearMessagingHelpers_rewards,
    tradeRewardsEndOfYearMessagingHelpers_rewards$key,
} from './__generated__/tradeRewardsEndOfYearMessagingHelpers_rewards.graphql';

type Rewards = tradeRewardsEndOfYearMessagingHelpers_rewards | null | undefined;
type RewardsRef = tradeRewardsEndOfYearMessagingHelpers_rewards$key | null;

const getRewardsData = (rewardsRef?: RewardsRef): Rewards =>
    readInlineData(rewardsFragment, rewardsRef);

export const canLevelUp = (rewardsRef?: RewardsRef): boolean => {
    const pointsNeededToLevelUp = Number(
        idx(getRewardsData(rewardsRef), d => d.pointsNeededToLevelUp)
    );
    return pointsNeededToLevelUp > 0 && pointsNeededToLevelUp < POINTS_THRESHOLD_LEVEL_UP;
};

export const willLoseStatus = (rewardsRef?: RewardsRef): boolean => {
    const rewardsData = getRewardsData(rewardsRef);
    const currentStatus = idx(rewardsData, d => d.currentProgram.programInfo.code);
    const pointsToMaintainStatus = idx(rewardsData, d => d.pointsToMaintainStatus) || 0;
    return currentStatus !== 'BRONZE' && pointsToMaintainStatus > 0;
};

export const isValidProgram = (rewardsRef?: RewardsRef): boolean => {
    const currentProgram =
        idx(getRewardsData(rewardsRef), d => d.currentProgram.programInfo.code) || '';
    return ['BRONZE', 'SILVER', 'GOLD', 'PLATINUM'].includes(currentProgram);
};

export const isValidDate = (): boolean => {
    return new Date() < SHOW_MODAL_TILL_DATE;
};

export const hasSeenRewardsMessagingModal = (): boolean => {
    return !!localStorage.getItem(HAS_SEEN_2019_EOY_REWARDS_MODAL_STORAGE_KEY);
};

export const logRewardsMessagingModalView = (): boolean => {
    return localStorage.setItem(HAS_SEEN_2019_EOY_REWARDS_MODAL_STORAGE_KEY, true);
};
